import { lazy, Suspense } from "react";
import PageHead from "@/components/PageHead";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";


const ModelSection = lazy(() => import("@/components/ModelSection"));
const ProductsSection = lazy(() => import("@/components/ProductsSection"));
const EnvironmentsSection = lazy(() => import("@/components/EnvironmentsSection"));
const ImpactSection = lazy(() => import("@/components/ImpactSection"));
const WhySection = lazy(() => import("@/components/WhySection"));
const GroupSection = lazy(() => import("@/components/GroupSection"));
const FoundersSection = lazy(() => import("@/components/FoundersSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <PageHead
        title="successioAI – KI-Lösungen, die im echten Unternehmen entstehen"
        description="successioAI entwickelt KI-Lösungen im eigenen operativen Betrieb: recruiTen.ai, supporTen.ai, targeTen.ai. DSGVO-konform, europäisch gehostet."
        path="/"
      />
      <Navbar />
      <main>
        <HeroSection />
        <Suspense fallback={<div className="min-h-[200px]" />}>
          <ModelSection />
          <ProductsSection />
          <EnvironmentsSection />
          <ImpactSection />
          <WhySection />
          <GroupSection />
          <FoundersSection />
          <FAQSection />
          <ContactSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
